// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2wZli","errors":"Errors_errors__E49qf"};